import { useEffect, useState } from 'react';
import styled from 'styled-components';

const ScrollToTop = () => {
	const [showUp, setShowUp] = useState(false);

	const handleScroll = () => {
		const scrollTop =
			document.documentElement.scrollTop || document.body.scrollTop;

		checkScroll(scrollTop);
	};

	const checkScroll = (scrollTop) => {
		setShowUp(scrollTop > 600);
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);

		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<ScrollBtn
			className={showUp ? 'show-up' : undefined}
			onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
		>
			<img alt="Arrow Up" src="/images/messaging-partners/arrow-up.svg" />
		</ScrollBtn>
	);
};

const ScrollBtn = styled.button`
	position: fixed;
	bottom: 80px;
	right: 30px;
	z-index: 9000;
	background: white;
	box-shadow: 0px 20px 40px rgba(34, 23, 106, 0.15);
	border-radius: 20px;
	padding: 20px;
	outline: none;
	opacity: 0;
	transition: 0.3s;
	cursor: pointer;
	visibility: hidden;

	@media (max-width: 600px) {
		bottom: 42px;
		right: 15px;
		transform: scale(0.8);
	}

	&:hover {
		box-shadow: 0px 4px 12px rgba(34, 23, 106, 0.15);
		transform: scale(0.97);
	}

	&.show-up {
		opacity: 1;
		visibility: visible;
	}
`;

export default ScrollToTop;
